import(/* webpackMode: "eager" */ "/app/src/app/login/vadyba/page.tsx");
